import { useNavigate } from "react-router";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { setVendorOrderValue } from "../vendorsSlice";
import { useAuth } from "react-oidc-context";

export const VendorListTools = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const vendorsstate = useAppSelector(state => state.vendorsstate);
  const auth = useAuth();

  const handleAdd = async () => {
    dispatch(setVendorOrderValue(vendorsstate.vendors.length));
    setTimeout(() => {
      navigate('/vendor-add');
    }, 1000)
  }

  return (
    <div className="padded-spread-container lr-padded-container">
      {auth.isAuthenticated && (
        <button
          type='button'
          className='btn'
          style={{ marginLeft: '0.5rem' }}
          onClick={() => handleAdd()}
        >
          Add Vendor
        </button>
      )}
      <div className="default-container"></div>
    </div>
  );
}
